import { useAssistant } from "ai/react"
import { createContext, useContext } from "react";

const ChatContext = createContext<ReturnType<typeof useAssistant> & {
  isLoading: boolean
  reload: () => void
}>(null!);

export const useChat = () => useContext(ChatContext);

export const ChatProvider = ({children}: {
  children: React.ReactNode
}) => {
  const chat = useAssistant({
    api: '/api/agent'
  });
  const reload = () => {
    let last_message
    const messages = chat.messages
    do {
      last_message = messages.pop()
    }
    while (last_message && last_message.role != 'user');

    if (last_message) {
      chat.setMessages(messages)
      chat.append(last_message);
    }
  }
  return <ChatContext.Provider value={{...chat, reload, isLoading: chat.status == 'in_progress'}}>{children}</ChatContext.Provider>
}